import produce from "immer";
import {
  CHANGE_FDES_PARAMETER_FORM,
  GET_FDES_PARAMETERS_SUCCESS,
  SAVE_FDES_FORM_FAILED,
  SAVE_FDES_FORM_SUCCESS,
  LOAD_FDES_PARAMETERS,
  SAVE_CURRENT_FDES_ID,
  SAVE_FDES_FORM,
  LOAD_REFERENCE_SUCCESS,
  CHANGE_SYNTHETIC_RESULT_FORM,
  CHANGE_MODULE_RESULT_FORM,
  CHANGE_CALCUL_NAME_FORM,
  SAVE_FDES_RESULT,
  SAVE_FDES_RESULT_SUCCESS,
  SAVE_FDES_RESULT_FAILED,
  CHANGE_PROJECT_NAME_FORM,
  UPDATE_CALCUL_SUCCESS,
  UPDATE_CALCUL,
  UPDATE_CALCUL_FAILED,
  SAVE_FDES_FORM_REAL_TIME,
  GET_FDES_METADATA_SUCCESS,
  POST_FDES_FILE_SUCCESS,
  CLEAR_CALCUL_INFORMATIONS,
  UPDATE_FORM_FIELDS,
  CLEAR_FIELDS_IMPORT_ERRORS,
  LOAD_CALCUL_DATA_SUCCESS,
  CLEAN_NAME_FORM,
  CHANGE_SIMULATION_MODE_FORM,
  UPGRADE_CALCUL,
  CLEAR_RECALC_AFTER_UPGRADE,
  UPDATE_FORM_GROUP_STATE,
  CLEAR_USER_PARAMETERS_GROUPS,
  ENABLE_RESULT_FORM_LOADER,
} from "../constants";
import { formatToCalculatedNumber, groupBy } from "../../../utils/transformer";
import { DEFAULT_INDICATOR_ID, DEFAULT_STEP_ID } from "../constants/indicators";
import { toast } from "react-toastify";

export const initialState = {
  calculName: "",
  projectName: "",
  simulationMode: undefined,
  resultForm: {
    isLoading: false,
    isSaved: false,
  },
  fdesParameterGroups: [],
  fdesParameters: [],
  userParametersGroups: [],
  form: {
    fields: [],
    currentFdesId: "",
    isLoading: false,
    isSaved: false,
    isFormUpdated: false,
  },
  calculateId: "",
  results: [],
  references: {
    indicators: [],
    steps: [],
  },
  preferences: {
    modules: [],
    graph: [],
    table: [],
    defaults: [],
  },
  synthetic: {
    fields: {
      indicator: {},
      step: {},
    },
  },
  module: {
    fields: {
      indicator: {},
    },
  },
  metadata: [],
  importFdesFormErrors: [],
  hasImportedFdesForm: false,
  closeImportFileModal: false,
  recalcAfterUpgrade: false,
};

const fdesReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case UPGRADE_CALCUL:
      // Flag a recalculation to run once the upgraded calcul parameters are loaded
      draft.recalcAfterUpgrade = true;
      break;
    case CLEAR_RECALC_AFTER_UPGRADE:
      draft.recalcAfterUpgrade = false;
      break;
    case LOAD_FDES_PARAMETERS:
      draft.fdesParameterGroups = [];
      draft.form = {
        fields: [],
        isLoading: false,
        currentFdesId: "",
        isSaved: false,
        isFormUpdated: false,
      };
      break;
    case GET_FDES_PARAMETERS_SUCCESS:
      formatFdesParametersResponse(draft, action.payload);
      break;
    case CHANGE_FDES_PARAMETER_FORM:
      changeFdesParametersForm(draft, action);
      break;
    case SAVE_FDES_FORM:
      draft.lastFormSave = draft.form.fields;
      draft.form.isLoading = true;
      draft.form.isSaved = true;
      draft.form.isFormUpdated = false;
      break;
    case SAVE_FDES_FORM_REAL_TIME:
      draft.lastFormSave = draft.form.fields;
      draft.form.isLoading = true;
      draft.form.isSaved = true;
      draft.form.isFormUpdated = false;
      break;
    case SAVE_CURRENT_FDES_ID:
      draft.form.currentFdesId = action.fdesId;
      break;
    case POST_FDES_FILE_SUCCESS:
      break;
    case SAVE_FDES_FORM_SUCCESS:
      draft.form.isLoading = false;
      if (
        action.payload &&
        action.payload.results &&
        action.payload.results.length > 0
      ) {
        draft.results = action.payload.results;
        draft.calculateId = action.payload._id;
      }
      if (
        action.payload &&
        action.payload.additionalResults &&
        action.payload.additionalResults.length > 0
      ) {
        draft.additionalResults = action.payload.additionalResults;
      }
      if (action.payload && action.payload.settings) {
        draft.settings = action.payload.settings;
      }
      if (Array.isArray(action.payload?.metadata)) {
        draft.metadata = action.payload.metadata;
      }
      if (draft.simulationMode === undefined) {
        draft.simulationMode = false;
      }
      break;
    case SAVE_FDES_FORM_FAILED:
      draft.form.isLoading = false;
      draft.form.isSaved = false;
      break;
    case LOAD_REFERENCE_SUCCESS:
      formatReferenceResponse(draft, action.payload);
      break;
    case CHANGE_SYNTHETIC_RESULT_FORM:
      draft.synthetic.fields[action.field] = action.value;
      break;
    case CHANGE_MODULE_RESULT_FORM:
      draft.module.fields.indicator = action.value;
      break;
    case CHANGE_CALCUL_NAME_FORM:
      draft.resultForm.isSaved = false;
      draft.calculName = action.value;
      break;
    case CHANGE_PROJECT_NAME_FORM:
      draft.resultForm.isSaved = false;
      draft.projectName = action.value;
      break;
    case CHANGE_SIMULATION_MODE_FORM:
      draft.resultForm.isSaved = false;
      draft.simulationMode = action.value || false;
      break;
    case SAVE_FDES_RESULT:
      draft.resultForm.isLoading = true;
      break;
    case GET_FDES_METADATA_SUCCESS:
      draft.metadata = action.payload.data;
      break;
    case SAVE_FDES_RESULT_SUCCESS:
      draft.resultForm.isLoading = false;
      draft.resultForm.isSaved = true;
      break;
    case UPDATE_CALCUL:
      draft.resultForm.isLoading = true;
      break;
    case UPDATE_CALCUL_SUCCESS:
      draft.simulationMode = action.payload.options?.simulationMode === true;
      draft.resultForm.isLoading = false;
      draft.resultForm.isSaved = true;
      break;
    case SAVE_FDES_RESULT_FAILED:
    case UPDATE_CALCUL_FAILED:
    case ENABLE_RESULT_FORM_LOADER:
      draft.resultForm.isLoading = false;
      break;
    case LOAD_CALCUL_DATA_SUCCESS:
      draft.additionalResults = [];
      draft.results = [];
      draft.settings = {};
      draft.projectName = "";
      draft.calculName = "";
      draft.simulationMode = undefined;

      if (action.payload.title) {
        draft.calculName = action.payload.title;
      }
      if (action.payload.project) {
        draft.projectName = action.payload.project;
      }
      if (action.payload.model?.settings?.simulation?.active === true) {
        draft.simulationMode = action.payload.options?.simulationMode === true;
      } else draft.simulationMode = false;

      try {
        if (action.payload) {
          if (action.payload._id) {
            draft.resultForm.isSaved = true;
            draft.form.isSaved = true;
          }

          if (action.payload.results) {
            draft.results = action.payload.results;
          }
          if (action.payload.additionalResults) {
            draft.additionalResults = action.payload.additionalResults;
          }
          if (action.payload.settings) {
            draft.settings = action.payload.settings;
          }
          if (action.payload.settings?.userParametersGroups) {
            draft.userParametersGroups =
              action.payload.settings.userParametersGroups;
          } else draft.userParametersGroups = [];

          if (action.payload.parameters) {
            action.payload.parameters.forEach((parameter) => {
              let index = draft.form.fields.findIndex(
                (x) => x.paramId === parameter.paramId,
              );
              let type = draft.fdesParameters.find(
                (x) => x.paramId === parameter.paramId,
              )
                ? draft.fdesParameters.find(
                  (x) => x.paramId === parameter.paramId,
                ).type
                : "";
              let values = draft.fdesParameters.find(
                (x) => x.paramId === parameter.paramId,
              )
                ? draft.fdesParameters.find(
                  (x) => x.paramId === parameter.paramId,
                ).values
                : [];
              let valueIndex = values.findIndex(
                (x) => x === parameter.paramValue,
              );
              if (draft.form.fields[index]) {
                draft.form.fields[index].value = {
                  value: getFormFieldValue(type, parameter, valueIndex),
                  label: parameter.paramValue,
                };
              }
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
      break;
    case CLEAN_NAME_FORM:
      draft.calculateId = "";
      draft.resultForm.isSaved = false;
      break;
    case CLEAR_CALCUL_INFORMATIONS:
      draft.calculName = "";
      draft.projectName = "";
      draft.simulationMode = undefined;
      draft.results = [];
      draft.settings = {};
      draft.additionalResults = [];
      break;
    case UPDATE_FORM_FIELDS:
      const errorsList = [];
      action.fields.forEach((field, index) => {
        if (!field.ParamId) {
          errorsList.push({
            paramId: "non défini",
            message: `Le champ ParamId est requis.`,
            line: index + 2,
          });
          return;
        }

        const editIndex = draft.form.fields.findIndex(
          (x) => x.paramId?.toString() === field.ParamId?.toString(),
        );

        if (editIndex !== -1) {
          let valueIndex = undefined;
          const param = draft.form.fields[editIndex];
          const paramType = param.type;

          if (paramType === "image" && (!field.Value || field.Value === "")) {
            return;
          }

          if (field.Value === undefined || field.Value === null) {
            errorsList.push({
              paramId: field.ParamId,
              message: `Le champ Value est requis.`,
              line: index + 2,
            });
            return;
          }

          const formFieldValue = getFormFieldValue(
            paramType,
            { paramValue: field.Value },
            valueIndex,
          );

          if (paramType === "select" || paramType === "button") {
            const values =
              draft.fdesParameters.find((x) => x.paramId === field.ParamId)
                ?.values || [];
            valueIndex = values.findIndex(
              (value) => value.trim() === field.Value.toString().trim(),
            );
            if (valueIndex === -1) {
              errorsList.push({
                paramId: field.ParamId,
                message: `La valeur "${field.Value}" n'existe pas dans la liste des valeurs possibles.`,
                line: index + 2,
              });
              return;
            }
          } else if (
            paramType === "numeric" ||
            paramType === "numericslider" ||
            paramType === "percent" ||
            paramType === "percentslider"
          ) {
            if (isNaN(formFieldValue)) {
              errorsList.push({
                paramId: field.ParamId,
                message: `La valeur "${field.Value}" n'est pas un nombre valide.`,
                line: index + 2,
              });
              return;
            } else {
              const rules =
                draft.fdesParameters.find((x) => x.paramId === field.ParamId)
                  ?.validationRules || [];
              const valueMin = rules
                .find((rule) => rule.type === "min")
                ?.value?.replaceAll(",", ".");
              const valueMax = rules
                .find((rule) => rule.type === "max")
                ?.value?.replaceAll(",", ".");

              if (valueMin && Number(formFieldValue) < Number(valueMin)) {
                errorsList.push({
                  paramId: field.ParamId,
                  message: `La valeur "${field.Value}" est inférieure à la valeur minimale (${valueMin}).`,
                  line: index + 2,
                });
                return;
              } else if (
                valueMax &&
                Number(formFieldValue) > Number(valueMax)
              ) {
                errorsList.push({
                  paramId: field.ParamId,
                  message: `La valeur "${field.Value}" est supérieure à la valeur maximale (${valueMax}).`,
                  line: index + 2,
                });
                return;
              }
            }
          } else if (
            paramType === "text" ||
            paramType === "textarea" ||
            paramType === "string"
          ) {
            //todo: check if max is set well need to limit text field length
            // if (field.Value?.trim().length > 100) {
            //   errorsList.push({
            //     paramId: field.ParamId,
            //     message: `La valeur ne peut pas dépasser 100 caractères.`,
            //     line: index + 2,
            //   });
            //   return;
            // }
          }

          draft.form.fields[editIndex] = {
            ...draft.form.fields[editIndex],
            value: {
              value: formFieldValue,
              label: paramType === "button" ? formFieldValue : field.Value,
            },
          };
        } else {
          errorsList.push({
            paramId: field.ParamId,
            message: `La valeur de ParamId ne correpont à aucun des paramètres de ce calcul.`,
            line: index + 2,
          });
          return;
        }
      });
      draft.importFdesFormErrors = errorsList;
      draft.hasImportedFdesForm = true;
      draft.form.isSaved = false;
      draft.resultForm.isSaved = false;
      draft.form.isFormUpdated = true;
      draft.closeImportFileModal = errorsList.length === 0;
      toast.success("Import du fichier terminé");
      break;
    case CLEAR_FIELDS_IMPORT_ERRORS:
      draft.importFdesFormErrors = [];
      draft.hasImportedFdesForm = false;
      draft.closeImportFileModal = false;
      break;
    case UPDATE_FORM_GROUP_STATE:
      if (action.groupName) {
        const groupIndex = draft.userParametersGroups.findIndex(
          (group) => group.name === action.groupName,
        );
        if (groupIndex !== -1) {
          draft.userParametersGroups[groupIndex].isOpen = action.value;
          draft.userParametersGroups[groupIndex].order = action.order;
        } else {
          draft.userParametersGroups.push({
            name: action.groupName,
            isOpen: action.value,
            order: action.order,
          });
        }
      }
      break;
    case CLEAR_USER_PARAMETERS_GROUPS:
      draft.userParametersGroups = [];
      break;
    default:
      return draft;
  }
});
/**
 * get the form field value when loaded.
 *
 * @param {*} type
 * @param {*} parameter
 * @param {*} valueIndex
 * @returns
 */
function getFormFieldValue(type, parameter, valueIndex) {
  if (type === "select") {
    return valueIndex || 0;
  } else if (type === "button") {
    return parameter.paramValue;
  } else if (type === "numeric" || type === "numericslider") {
    return parameter.paramValue && parameter.paramValue !== "0"
      ? formatToCalculatedNumber(parameter.paramValue)
      : "0";
  } else if (type === "percent" || type === "percentslider") {
    let value = parameter.paramValue;
    if (parameter.paramValue.toString().includes("%")) {
      value = parameter.paramValue
        .toString()
        .slice(0, parameter.paramValue.toString().length - 1);
    }
    return formatToCalculatedNumber(value);
  }
  return parameter.paramValue;
}

function changeFdesParametersForm(draft, action) {
  if (action && action.paramId && action.value !== undefined) {
    draft.form.isFormUpdated = true;
    draft.form.isSaved = false;
    draft.resultForm.isSaved = false;
    const editIndex = draft.form.fields.findIndex(
      (x) => x.paramId === action.paramId,
    );
    draft.form.fields[editIndex] = {
      ...draft.form.fields[editIndex],
      paramId: action.paramId,
      value: action.value,
    };
  }
}

function formatFdesParametersResponse(draft, payload) {
  if (payload && payload.length > 0) {
    draft.fdesParameters = payload;
    const groupedParameters = groupBy(payload, "group");
    draft.fdesParameterGroups = Object.keys(groupedParameters).map(
      (groupName) => ({
        name: groupName,
        parameters: groupedParameters[groupName]
          ? groupedParameters[groupName].sort((a, b) =>
            a.order < b.order ? -1 : 1,
          )
          : [],
        isGeneralParameter:
          groupedParameters[groupName] &&
          groupedParameters[groupName][0] &&
          groupedParameters[groupName][0].isGeneralParameter,
      }),
    );
    draft.fdesParameterGroups = draft.fdesParameterGroups.sort((a) =>
      a.isGeneralParameter ? -1 : 1,
    );
    const sUsrArg = navigator.userAgent;
    if (sUsrArg.indexOf("Firefox") > -1)
      draft.fdesParameterGroups = draft.fdesParameterGroups.reverse();

    setDefaultFormValue(draft, groupedParameters);
  }
}

function formatReferenceResponse(draft, payload) {
  if (payload && payload.indicators) {
    const indicators = Object.keys(payload.indicators).map(
      (indicatorId) => payload.indicators[indicatorId],
    );
    const defaultIndicator = indicators.find(
      (x) =>
        x.id ===
        (payload.preferences.resultPage.defaults.indicator
          ? payload.preferences.resultPage.defaults.indicator
          : DEFAULT_INDICATOR_ID),
    );

    draft.references.indicators = indicators;
    draft.synthetic.fields.indicator = {
      value: defaultIndicator && defaultIndicator.id,
      label: defaultIndicator && defaultIndicator.title,
    };
    draft.module.fields.indicator = {
      value: defaultIndicator && defaultIndicator.id,
      label: defaultIndicator && defaultIndicator.title,
    };
  }
  if (payload && payload.steps) {
    const steps = Object.keys(payload.steps).map(
      (indicatorId) => payload.steps[indicatorId],
    );
    const defaultStep = steps.find(
      (x) =>
        x.id ===
        (payload.preferences.resultPage.defaults.step
          ? payload.preferences.resultPage.defaults.step
          : DEFAULT_STEP_ID),
    );

    draft.references.steps = steps;
    draft.synthetic.fields.step = {
      value: defaultStep && defaultStep.id,
      label: defaultStep && `${defaultStep.acronym} - ${defaultStep.title}`,
    };
  }

  if (payload && payload.preferences) {
    if (
      payload.preferences &&
      payload.preferences.resultPage &&
      payload.preferences.resultPage.modules &&
      payload.preferences.resultPage.modules.length > 0
    ) {
      draft.preferences.modules = payload.preferences.resultPage.modules;
    }
    if (
      payload.preferences &&
      payload.preferences.resultPage &&
      payload.preferences.resultPage.graph &&
      payload.preferences.resultPage.graph.length > 0
    ) {
      draft.preferences.graph = payload.preferences.resultPage.graph;
    }
    if (
      payload.preferences &&
      payload.preferences.resultPage &&
      payload.preferences.resultPage.table &&
      payload.preferences.resultPage.table.length > 0
    ) {
      draft.preferences.table = payload.preferences.resultPage.table;
    }
    if (
      payload.preferences &&
      payload.preferences.resultPage &&
      payload.preferences.resultPage.defaults &&
      payload.preferences.resultPage.defaults.length > 0
    ) {
      draft.preferences.defaults = payload.preferences.resultPage.defaults;
    }
  }
}

function setDefaultFormValue(draft, groupedParameters) {
  if (groupedParameters) {
    let grouppedFields = [];
    Object.keys(groupedParameters).map(
      (groupName) =>
      (grouppedFields = [
        ...grouppedFields,
        ...groupedParameters[groupName].map(
          (parameter) =>
            parameter.paramId && {
              paramId: parameter.paramId,
              externalId: parameter.externalId,
              value: {
                value: parameter.defaultValue ? parameter.defaultValue : "",
                label: parameter.defaultValue ? parameter.defaultValue : "",
              },
              type: parameter.type,
              isGeneralParameter: parameter.isGeneralParameter,
            },
        ),
      ]),
    );
    draft.form.fields = grouppedFields;
  }
}

export default fdesReducer;
